export const DTD_CANCEL_REASON = {
  FORCE_MAJEURE: 'FORCE_MAJEURE',
  CHANGE_ROUTE: 'CHANGE_ROUTE',
  CHANGE_SCHEDULE: 'CHANGE_SCHEDULE',
  OTHER: 'OTHER_REASON',
};
export default {};
